<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <!-- Start Table -->
            <div
              id="datatable_wrapper"
              class="dataTables_wrapper dt-bootstrap4 no-footer"
            >
              <div class="row">
                <div class="col-sm-12 col-md-5">
                  <div class="dataTables_length" id="datatable_length">
                    <label
                      >Show
                      <select
                        name="datatable_length"
                        aria-controls="datatable"
                        v-model="perPage"
                        class="
                          custom-select custom-select-sm
                          form-control
                          form-control-sm
                          form-select
                          form-select-sm
                        "
                      >
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                      </select>
                      entries</label
                    >
                  </div>
                </div>

                <div class="col-sm-12 col-md-7">
                  <div class="row">
                    <div class="col-sm-12 col-md-9">
                      <div
                        id="datatable_filter"
                        class="dataTables_filter h-100"
                      >
                        <label class="h-100"
                          >Search:<input
                            type="search"
                            class="form-control form-control-sm h-100"
                            placeholder=""
                            aria-controls="datatable"
                            v-model.trim="search"
                        /></label>
                      </div>
                    </div>

                    <div class="col-sm-12 col-md-3">
                      <button
                        type="button"
                        @click="
                          $router.push({
                            path: '/mpg/organizations/experian/search',
                          })
                        "
                        class="btn btn-success waves-effect waves-light w-100"
                      >
                        Create Organization
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 table-responsive">
                  <b-table
                    class="
                      table
                      mt-2
                      dt-responsive
                      nowrap
                      w-100
                      dataTable
                      no-footer
                      dtr-inline
                    "
                    id="datatable"
                    :sort-by="sortBy"
                    :sort-desc="sortDesc"
                    :fields="column"
                    :items.sync="items"
                    :per-page="perPage"
                    :busy.sync="loading"
                    show-empty
                    ref="table"
                    @sort-changed="sortChanged"
                  >
                    <template #cell(name)="data">
                      <router-link
                        :to="
                          '/mpg/organizations/' +
                          data.item.organization_id +
                          '/details'
                        "
                      >
                        {{ data.value }}
                      </router-link>
                    </template>
                    <template #table-busy>
                      <div class="text-center text-primary my-2">
                        <b-spinner class="align-middle mr-2"></b-spinner>
                        <strong>Loading...</strong>
                      </div>
                    </template>
                  </b-table>
                </div>
              </div>
              <div class="row" v-if="rows > 0">
                <div class="col-sm-12 col-md-5">
                  <div
                    class="dataTables_info"
                    id="datatable_info"
                    role="status"
                    aria-live="polite"
                  >
                    Showing {{ (currentPage - 1) * perPage + 1 }} to
                    {{
                      currentPage * perPage > rows
                        ? rows
                        : currentPage * perPage
                    }}
                    of {{ rows }} entries
                  </div>
                </div>
                <div class="col-sm-12 col-md-7">
                  <div
                    class="dataTables_paginate paging_simple_numbers"
                    id="datatable_paginate"
                  >
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                      aria-controls="my-table"
                      v-on:change="onPageChange"
                    ></b-pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- End Card Body -->
        </div>
      </div>
      <!-- End Col -->
    </div>
  </div>
</template>

<script>
import { organizationsService } from '../services/organizations.service'
import moment from 'moment'
import { debounce } from '../helpers'

export default {
  name: 'Organizations',
  components: {},
  data () {
    return {
      perPage: 10,
      currentPage: 1,
      items: [],
      count: 0,
      search: '',
      loading: true,
      column: [
        {
          key: 'name',
          sortable: true,
          label: 'Name',
          class: 'sorting'
        },
        {
          key: 'tax_id',
          sortable: true,
          label: 'Tax ID',
          class: 'sorting'
        },
        {
          key: 'duns_number',
          sortable: true,
          label: 'DUNS Number',
          class: 'sorting'
        },
        {
          key: 'bin_number',
          sortable: true,
          label: 'EXPERIAN ID',
          class: 'sorting'
        },
        {
          key: 'zoominfo_id',
          sortable: true,
          label: 'ZOOM INFO ID',
          class: 'sorting'
        }
      ],
      sortBy: 'name',
      sortDesc: false
    }
  },
  computed: {
    rows () {
      return this.count
    },
    itemsTable () {
      return this.items
    }
  },
  watch: {
    search: debounce(function (newVal) {
      this.loadData()
    }, 500),
    perPage (newVal) {
      this.loadData()
    },
    sortBy (newVal) {
      this.loadData()
    },
    sortDesc (newVal) {
      this.loadData()
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    moment,
    loadData () {
      this.loading = true
      organizationsService
        .getData({
          q: 'q=' + this.search,
          ordering: this.sortDesc ? '-' + this.sortBy : this.sortBy,
          limit: this.perPage,
          offset: (this.currentPage - 1) * this.perPage
        })
        .then((rs) => {
          this.items = rs.results
          this.count = rs.count
          setTimeout(() => {
            this.loading = false
          }, 0)
        })
        .finally(() => {
          this.loading = false
        })
    },
    sortChanged (e) {
      this.sortDesc = e.sortDesc
      this.sortBy = e.sortBy
    },
    onPageChange (value) {
      this.currentPage = value
      this.loadData()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Organizations.vue